// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14xX5","colBig":"styles_colBig__12vTR","colSmall":"styles_colSmall__czLtr"};